import { ArrowLeftIcon } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { RoomSystemForm } from "@/features/room-systems/components/room-system.form";

export function AddRoomSystem() {
  return (
    <section>
      <div className="mb-6">
        <Button variant="link" asChild>
          <Link to="/admin/room-systems">
            <ArrowLeftIcon className="mr-2 h-4 w-4" /> Back to Room Systems
          </Link>
        </Button>
      </div>
      <OnboardingHeader title="Add Room System" className="mb-6" />
      <RoomSystemForm />
    </section>
  );
}
